import * as translation from "./it-IT.json";

export const translationItIT = translation.default;
